module.exports = __webpack_public_path__ + "static/media/(V)_MG_5954_-_Cia_Termal_Beachewear_-_Moda_Feminina.7d1ff8b9.jpg";